function createIconElement(iconUrl) {
    const div = document.createElement("div");
    div.innerHTML = `
      <img src="${iconUrl}" style="width: 30px; height: 30px;" />
    `;
    return div;
  };
  export const getCustomIcon = (type) => {
    const baseIconUrl = "https://img.icons8.com/color/48/";
    const icons = {
      accounting: "bank-card-back-side",
      airport: "airport",
      amusement_park: "roller-coaster",
      aquarium: "aquarium",
      art_gallery: "paint-palette",
      atm: "atm",
      bakery: "bread",
      bank: "bank",
      bar: "bar",
      beauty_salon: "beauty-salon",
      bicycle_store: "bicycle",
      book_store: "books",
      bowling_alley: "bowling",
      bus_station: "bus",
      cafe: "coffee",
      campground: "tent",
      car_dealer: "car",
      car_rental: "car-rental",
      car_repair: "car-repair",
      car_wash: "car-wash",
      casino: "slot-machine",
      cemetery: "grave",
      church: "church",
      city_hall: "city-hall",
      clothing_store: "t-shirt",
      convenience_store: "shop",
      courthouse: "courthouse",
      dentist: "tooth",
      department_store: "department-store",
      doctor: "doctor-male",
      drugstore: "drugstore",
      electrician: "electrical",
      electronics_store: "electronics",
      embassy: "embassy",
      fire_station: "fire-station",
      florist: "flower-shop",
      funeral_home: "funeral",
      furniture_store: "sofa",
      gas_station: "gas-station",
      gym: "gym",
      hair_care: "hair-dryer",
      hardware_store: "tools",
      hindu_temple: "hindu-temple",
      home_goods_store: "home",
      hospital: "hospital",
      insurance_agency: "insurance",
      jewelry_store: "diamond",
      laundry: "washing-machine",
      lawyer: "lawyer",
      library: "bookshelf",
      light_rail_station: "tram",
      liquor_store: "wine-bottle",
      local_government_office: "government",
      locksmith: "key",
      lodging: "hotel-room",
      meal_delivery: "meal-delivery",
      meal_takeaway: "meal",
      mosque: "mosque",
      movie_rental: "video",
      movie_theater: "theatre-mask",
      moving_company: "moving-truck",
      museum: "museum",
      night_club: "dj",
      painter: "paint-brush",
      park: "park",
      parking: "parking",
      pet_store: "pet-commands-train",
      pharmacy: "pill",
      physiotherapist: "massage",
      plumber: "plumber",
      police: "policeman-male",
      post_office: "post-office",
      primary_school: "school",
      real_estate_agency: "real-estate",
      restaurant: "restaurant",
      roofing_contractor: "roof",
      rv_park: "camper-van",
      school: "school-building",
      secondary_school: "graduation-cap",
      shoe_store: "sneakers",
      shopping_mall: "shopping-mall",
      spa: "spa",
      stadium: "stadium",
      storage: "storage",
      store: "store",
      subway_station: "subway",
      supermarket: "supermarket",
      synagogue: "synagogue",
      taxi_stand: "taxi",
      tourist_attraction: "tourist",
      train_station: "train",
      transit_station: "train-station",
      travel_agency: "travel-agency",
      university: "university",
      veterinary_care: "veterinarian",
      zoo: "zoo"
    };
  
    const iconName = icons[type] || "marker";
    return `${baseIconUrl}${iconName}.png`;
  };
  
  function attachInfoWindow(marker, map, contentHtml) {
    const infoWindow = new google.maps.InfoWindow({
      content: contentHtml
    });
  
    marker.addListener("click", () => {
      infoWindow.open({
        anchor: marker,
        map,
        shouldFocus: false
      });
    });
  }

function formatMetricValue(value, metricType) {
    if (value === undefined || value === null || value === '') {
        return { value: 'Unavailable', hasValue: false };
    }

    const numValue = parseFloat(value.toString().replace(/[^0-9.-]/g, ''));
    if (isNaN(numValue)) {
        return { value: 'Unavailable', hasValue: false };
    }

    let formattedValue;
    if (metricType === 'currency') {
        formattedValue = numValue.toLocaleString('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
    } else if (metricType === 'percentage') {
        formattedValue = numValue.toFixed(2);
    } else if (metricType === 'int') {
        formattedValue = Math.round(numValue).toLocaleString('en-US');
    } else {
        formattedValue = numValue.toString();
    }

    return { value: formattedValue, hasValue: true };
}

export default {
    state: {
        _pendingRequests: {},
        metricGroups: [],
        lastRequest: null, // Track the last POI request parameters
        isUpdatingMapBounds: false, // Track if we're currently updating the map bounds
        
        poi: {
            availableTypes: [],
        },
        customMetricCalculations: {
            'age_median': (min, value, max) => {
                let median = (min + max) / 2;
                return 1 - (Math.abs(value - median) / (max - min) * 2);
            }
        },
        selectedStates: [],
        selectedMetrics: [],
        stateGeoJSON: null,
        visibleFeatures: [],
        data: null,
        isCollapsed: false,
        minZoom: 8,
        minScore: 0,
        boundary: 'zip',
        buckets: [100, 80, 60, 40, 20],
        bucketColors: [
            "#77FF00",
            "#CCFF00",
            "#FFDD00",
            "#FF8800",
            "#FF0000",
        ],
        fillOpacity: 0.7,
        strokeWeight: 0.7,
        poiMarkersByType: {},
        poiLoading: false
    },

    mutations: {
        SET_POI_LOADING(state, status) {
            state.poiLoading = status;
        },
        SET_AVAILABLE_POI_TYPES(state, types) {
            state.poi.availableTypes = types;
        },
        setSelectedPOIs(state, selectedTypes) {
            if (!state.poi) {
                state.poi = {};
            }
            state.poi.selectedTypes = Array.isArray(selectedTypes) ? [...selectedTypes] : [];
        },
        CLEAR_ALL_METRICS(state) {
            // Reset selected metrics
            state.selectedMetrics = [];
            
            // Reset all metric weights in metricGroups
            if (state.metricGroups && Array.isArray(state.metricGroups)) {
                state.metricGroups.forEach(group => {
                    if (group.metrics && Array.isArray(group.metrics)) {
                        group.metrics.forEach(metric => {
                            metric.weight = 0;
                        });
                    }
                });
            }
        },
    },

    actions: {
        async clearAllMetrics({ commit, state, dispatch, rootState }) {
            commit('CLEAR_ALL_METRICS');
            
            // Clear the map first
            if (rootState.reatlas.map) {
                // Clear any existing data layers
                if (rootState.reatlas.map.data) {
                    rootState.reatlas.map.data.setMap(null);
                    rootState.reatlas.map.data = new google.maps.Data({ map: rootState.reatlas.map });
                }
                
                // If states are selected, reload them one by one
                if (state.selectedStates && state.selectedStates.length > 0) {
                    // Store the current selected states
                    const currentStates = [...state.selectedStates];
                    
                    // Clear the states
                    state.selectedStates = [];
                    
                    // Reload each state
                    for (const stateCode of currentStates) {
                        await dispatch('loadZipBoundariesForState', {
                            state: stateCode,
                            callback: async () => {
                                await dispatch('loadCRESiteIQZipCodeData');
                                await dispatch('refreshScores');
                            }
                        });
                        // Add the state back to selectedStates
                        if (!state.selectedStates.includes(stateCode)) {
                            state.selectedStates.push(stateCode);
                        }
                    }
                } else {
                    // If no state selected, just remap existing data
                    await dispatch('remapCRESiteIQData');
                }
            }
        },
        async fetchPlaceTypes({ state, commit }) {
            if (state.poi.availableTypes.length > 0) {
              return state.poi.availableTypes;
            }     
          
            try {
              const response = await axios.get('/api/map/cresiteiq/place_types', {
                headers: {
                  'Accept': 'application/json',
                  'X-Requested-With': 'XMLHttpRequest'
                },
                timeout: 5000
              });
          
              const types = Array.isArray(response.data) ? response.data : [];
              commit('SET_AVAILABLE_POI_TYPES', types);
          
              return types;
            } catch (error) {
              commit('SET_AVAILABLE_POI_TYPES', []);              
              return [];
            } 
          },
          
        
        async loadCRESiteIQMetrics(context) {
            await axios.get("/api/map/cresiteiq_metrics").then(response => {
                context.state.metricGroups = response.data;
            });
        },

        async loadNearbyPlaces({ rootState, state, commit }, { location, types, radius }) {
            if (!location || !types?.length) return;
          
            const cacheKey = `${location.lat},${location.lng}-${types.sort().join(',')}-${radius}`;
            if (state._pendingRequests?.[cacheKey]) return;
          
            // Set loader ON
            commit('SET_POI_LOADING', true);
          
            state._pendingRequests = {
              ...state._pendingRequests,
              [cacheKey]: true
            };
          
            const map = rootState.reatlas?.map;
            if (!map) return;
          
            try {
              const response = await axios.get("/api/map/cresiteiq/fetch_nearby_pois", {
                params: {
                  lat: location.lat,
                  lng: location.lng,
                  radius,
                  types: types.join(",")
                }
              });
          
              const data = response.data;
          
              for (const [type, places] of Object.entries(data)) {
                const existingMarkers = state.poiMarkersByType[type] || [];
                const existingById = new Map(existingMarkers.map(m => [m.placeId, m]));
          
                const newMarkers = [];
          
                for (const place of places) {
                  const placeId = place.id || place.place_id;
                  if (!place.geometry?.location || existingById.has(placeId)) {
                    newMarkers.push(existingById.get(placeId));
                    continue;
                  }
          
                  const latLng = new google.maps.LatLng(
                    place.geometry.location.lat,
                    place.geometry.location.lng
                  );
          
                  const iconUrl = getCustomIcon(type);
                  const title = place.name || "Unnamed POI";
                  const content = createIconElement(iconUrl, title);
          
                  const marker = new google.maps.marker.AdvancedMarkerElement({
                    map,
                    position: latLng,
                    title,
                    content
                  });
          
                  marker.placeId = placeId;
                  marker.poiType = type;
          
                  const infoHtml = `
                    <div style="min-width:200px">
                      <strong>${title}</strong><br/>
                      <small>${place.vicinity || "No address available"}</small><br/>
                      <small>Type: ${type}</small>
                    </div>
                  `;
                  attachInfoWindow(marker, map, infoHtml);
          
                  newMarkers.push(marker);
                }        
                state.poiMarkersByType[type] = newMarkers;
              }      
              state.lastPoiCacheKey = cacheKey;  
            } catch (err) {
              console.error("Failed loading POIs:", err);
            } finally {
              const { [cacheKey]: _, ...rest } = state._pendingRequests;
              state._pendingRequests = rest;
              commit('SET_POI_LOADING', false);
            }
          },

        removePOIType({ commit, state }, type) {
            if (!Array.isArray(state.poiMarkersByType[type])) return;
            state.poiMarkersByType[type].forEach(marker => marker?.setMap?.(null));
            delete state.poiMarkersByType[type];
            const updatedTypes = state.poi.selectedTypes.filter(t => t !== type);
            commit('setSelectedPOIs', updatedTypes);
        },

        async loadCRESiteIQData(context) {
            context.rootState.reatlas.infoWindow.close();

            if (context.state.boundary == 'state') {
                await context.dispatch('loadCRESiteIQStateData');
            } else if (context.state.boundary == 'zip') {
                await context.dispatch('loadCRESiteIQZipCodeData');
            }
        },

        async loadCRESiteIQStateData(context) {
            console.log('loading data');
            context.rootState.reatlas.mapLoading = true;

            if (context.state.data == null) {
                context.rootState.reatlas.map.data.loadGeoJson(
                    "/mapping/us_states.json",
                    null,
                    async function (features) {
                        features.map(feature => {
                            feature.setProperty('type', "area");
                        });

                        context.rootState.reatlas.map.data.setMap(context.rootState.reatlas.map);

                        await axios.post("/api/map/cresiteiq_data/by-state")
                            .then(response => {
                                context.state.data = response.data;
                            }).finally(async () => {
                                await context.dispatch('filterCRESiteIQData');

                                await context.dispatch('initCRESiteIQListeners');
                            });
                    }
                );
            } else {
                context.rootState.reatlas.map.data.setMap(context.rootState.reatlas.map);

                await axios.post("/api/map/cresiteiq_data/by-state")
                    .then(response => {
                        context.state.data = response.data;
                    }).finally(async () => {
                        await context.dispatch('filterCRESiteIQData');

                        await context.dispatch('initCRESiteIQListeners');
                    });
            }

            // await context.dispatch('refreshScores');

            context.rootState.reatlas.mapLoading = false;
        },

        async loadCRESiteIQZipCodeData(context, filterData = true) {
            if (!context.state.selectedStates.length) return;

            let stateAbbreviations = context.state.selectedStates.map(state => {
                let stateRow = _.find(context.rootState.reatlas.states, ['name', state]);

                if (stateRow) return stateRow['state'];
            })

            await axios.post("/api/map/cresiteiq_data", {
                'states': stateAbbreviations,
                'filters': context.state.selectedMetrics
            }).then(response => {
                context.state.data = response.data;
            }).finally(async () => {
                if (filterData) {
                    await context.dispatch('filterCRESiteIQData');
                }

                await context.dispatch('initCRESiteIQListeners');
            });
        },

        async loadCRESiteIQForZipCode(context, zipCode) {
            return await axios.post("/api/map/cresiteiq_data/by-zip", {
                'zip': zipCode
            }).then(response => {
                return response.data;
            });
        },

        async remapCRESiteIQData(context) {
            console.log('start remap');
            context.state.data = null;
            context.state.selectedStates = [];
            await context.dispatch('clearCRESiteIQMap');

            if (context.state.boundary == 'zip') {
                // remove metrics that are state only
                context.state.selectedMetrics = _.filter(context.state.selectedMetrics, metric => {
                    if (metric.granularity == 'state') {
                        metric.weight = 0;
                    }

                    return metric.granularity == 'zip';
                });

                if (context.rootState.reatlas.map.getZoom() <= context.state.minZoom) {
                    return;
                }

                let statesInView = await context.dispatch('getStatesWithinMapBounds');

                context.state.selectedStates = statesInView.map(state => state.name);
            } else if (context.state.boundary == 'state') {
                // remove metrics that are zip only
                context.state.selectedMetrics = _.filter(context.state.selectedMetrics, metric => {
                    if (metric.granularity == 'zip') {
                        metric.weight = 0;
                    }
                    return metric.granularity == 'state';
                });
            }

            await context.dispatch('loadCRESiteIQData', false);

            if (context.state.boundary == 'zip') {
                for await (const state of context.state.selectedStates) {
                    await context.dispatch('loadZipBoundariesForState', {
                        state: state,
                        callback: async () => {
                            await context.dispatch('filterCRESiteIQData', state);
                            await context.dispatch('refreshScores', state);
                        }
                    });
                }
            }

            console.log('end remap');
        },

        async filterCRESiteIQData(context, forState) {
            console.log('start filter', forState);
            context.rootState.reatlas.infoWindow.close();
            console.log('map loading on');
            context.rootState.reatlas.mapLoading = true;

            await context.dispatch('resetCRESiteIQMap', forState);

            await context.state.selectedMetrics.forEach(metric => {
                // if (metric.filter_level_min == metric.min_value && metric.filter_level_max == metric.max_value) {
                //     return;
                // }

                console.log('-------------------------------------------------');
                console.log('metric', metric.slug, metric, forState);
                console.log('-------------------------------------------------');

                context.rootState.reatlas.map.data.forEach(feature => {
                    // if feature is not a state, zip, or other area boundary, skip it
                    if (feature.getProperty('type') != 'area') {
                        return;
                    }

                    // if feature is not for the state we are processing, skip it
                    if (forState != undefined && !feature.getProperty('ste_name').includes(forState)) {
                        return;
                    }

                    // if feature is invisible because it's already been filtered out, skip it
                    if (feature.getProperty('visible') === false) {
                        return;
                    }

                    // determine if feature should be filtered out based on current metric filter
                    let zip = feature.getProperty('zcta5_code');

                    let metricData = context.state.boundary == 'state'
                        ? feature.getProperty('metricData')
                        : _.find(context.state.data, ['zip', zip[0]]);

                    if (!metricData) return;

                    let min = parseFloat(metric.filter_level_min);
                    let max = parseFloat(metric.filter_level_max);
                    let row = context.state.boundary == 'state'
                        ? metricData.data
                        : _.find(metricData.data, ['metric_id', metric.id]);

                    if (!row) return;

                    // Parse the value, defaulting to null for invalid or missing values
                    let value = null;
                    if (row['value'] !== undefined && row['value'] !== null && row['value'] !== '') {
                        const parsed = parseFloat(row['value']);
                        value = isNaN(parsed) ? null : parsed;
                    }
                    let isVisible = true; // Start with all features visible

                    // Special handling for boolean metrics
                    if (metric.type === 'bool' && metric.filter_type === 'range') {
                        // For boolean metrics with range filter:
                        // - If min=0 and max=0: show only non-Right to Work states (value === 0 or null/undefined)
                        // - If min=1 and max=1: show only Right to Work states (value === 1)
                        // - If min=0 and max=1 or any other range: show all states
                        if (min === 0 && max === 0) {
                            isVisible = value === 0 || value === null || value === undefined;
                        } else if (min === 1 && max === 1) {
                            isVisible = value === 1;
                        } else {
                            isVisible = true;
                        }
                    } else if (metric.filter_type === 'lt') {
                        // For 'less than', show if value is less than the selected value
                        isVisible = value < min;
                    } else if (metric.filter_type === 'gt') {
                        // For 'greater than', show if value is greater than or equal to the selected value
                        isVisible = value > 0; // For gt, show only true (1) values
                    } else {
                        // Original numeric comparison logic for non-boolean metrics
                        if (metric.filter_type === 'lt' && min !== metric.min_value) {
                            isVisible = value < min;
                        } else if (metric.filter_type === 'gt' && min !== metric.max_value) {
                            isVisible = value >= min;
                        } else if (metric.filter_type === 'range' &&
                                (min !== metric.min_value || max !== metric.max_value)) {
                            isVisible = (value >= min && value <= max);
                        }
                    }

                    feature.setProperty('visible', isVisible);

                    context.rootState.reatlas.map.data.overrideStyle(feature, {
                        fillColor: feature.getProperty('color'),
                        strokeWeight: feature.getProperty('strokeWeight') || context.state.strokeWeight,
                        visible: isVisible
                    });
                });
            });

            if (context.state.boundary == 'state') {
                await context.dispatch('scoreCRESiteIQStates');
                await context.dispatch('refreshScores');
            } else if (context.state.boundary == 'zip') {
                await context.dispatch('scoreCRESiteIQZips');
            }

            console.log('map loading off');
            context.rootState.reatlas.mapLoading = false;
        },

        async initCRESiteIQListeners(context) {
            return;
        },

        async rescore(context) {
            if (context.state.boundary == 'state') {
                await context.dispatch('scoreCRESiteIQStates');
            } else if (context.state.boundary == 'zip') {
                await context.dispatch('scoreCRESiteIQZips');
            }

            await context.dispatch('refreshScores');
        },

        async refreshScores(context, forState) {
            console.log('refreshing scores');
            let features = [];

            // remove features that are filtered out
            context.rootState.reatlas.map.data.forEach(feature => {
                if (feature.getProperty('type') == 'area' && feature.getProperty('visible') == true) {
                    features.push(feature);
                }
            });

            // sort by score
            context.state.visibleFeatures = _.sortBy(features, (feature) => {
                return -feature.getProperty('score') || 0;
            });
            return;

        },

        async loadZipBoundariesForState(context, parameters) {
            let stateRecord = _.find(context.rootState.reatlas.states, ['name', parameters.state]);

            if (!stateRecord) return;

            context.rootState.reatlas.map.data.loadGeoJson(
                "/mapping/zipcode/" + stateRecord.geo_json_file,
                null,
                function (features) {
                    features.map(feature => {
                        feature.setProperty('type', "area");
                        feature.setProperty('color', "#7a7a7a");
                        feature.setProperty('visible', true);

                        context.rootState.reatlas.map.data.overrideStyle(feature, {
                            fillColor: "#7a7a7a",
                            fillOpacity: context.state.fillOpacity,
                            strokeWeight: context.state.strokeWeight,
                            visible: true
                        });
                    });

                    parameters.callback()
                }
            );
        },

        async removeZipBoundariesForState(context, state) {
            context.rootState.reatlas.map.data.forEach(feature => {
                if (feature.getProperty('type') == 'area' && feature.getProperty('ste_name').includes(state)) {
                    context.rootState.reatlas.map.data.remove(feature);
                }
            });
        },

        async toggleInfoWindow(context, feature) {
            // currently no info window is open
            if (context.rootState.reatlas.infoWindow.getMap() == null) {
                if (context.state.boundary == 'zip') {
                    let postalCode = feature.getProperty('zcta5_code')[0];
                    let postalCodeRow = _.find(context.state.data, ['zip', postalCode]);
                    var latLng = new google.maps.LatLng(postalCodeRow.latitude, postalCodeRow.longitude);
                } else if (context.state.boundary == 'state') {
                    let stateName = feature.getProperty('NAME');
                    let state = _.find(context.rootState.reatlas.states, ['name', stateName]);

                    latLng = new google.maps.LatLng(state.latitude, state.longitude);
                }

                let content = context.state.boundary == 'state'
                    ? await context.dispatch('generateCRESiteIQStateInfoWindow', feature)
                    : await context.dispatch('generateCRESiteIQZipInfoWindow', feature);

                context.rootState.reatlas.map.data.overrideStyle(feature, { strokeWeight: 3 });
                context.rootState.reatlas.infoWindow.setContent(content);
                context.rootState.reatlas.infoWindow.setPosition(latLng);
                context.rootState.reatlas.infoWindow.setOptions({ pixelOffset: new google.maps.Size(0, -10) });
                context.rootState.reatlas.infoWindow.open(context.rootState.reatlas.map, feature)

                // info window is open, close it
            } else {
                context.rootState.reatlas.infoWindow.close();
            }
        },

        async generateCRESiteIQStateInfoWindow(context, feature) {
            let state = feature.getProperty('NAME');
            let stateScore = feature.getProperty('score') || '-';
            let stateAbbreviation = _.find(context.rootState.reatlas.states, ['name', state])['state'];

            // Ensure filterMetrics function exists in the global scope
            if (typeof window.filterMetrics !== 'function') {
                window.filterMetrics = function() {
                    const input = document.getElementById('metricSearch');
                    if (!input) return;
                    
                    const filter = input.value.toLowerCase();
                    const table = document.querySelector('.overflow-y-auto table');
                    if (!table) return;
                    
                    const rows = table.querySelectorAll('tbody tr');
                    
                    rows.forEach(row => {
                        const text = row.textContent.toLowerCase();
                        row.style.display = text.includes(filter) ? '' : 'none';
                    });
                    
                    // Show/hide empty groups
                    const groups = table.querySelectorAll('tbody');
                    groups.forEach(group => {
                        const hasVisibleRows = Array.from(group.querySelectorAll('tr')).some(
                            row => row.style.display !== 'none'
                        );
                        group.style.display = hasVisibleRows ? '' : 'none';
                    });
                };
            }

            // Build a single table with one header and group each metric group as a tbody
            let tableHtml = `
                <table class="border-spacing-2 w-full">
                    <thead>
                        <tr>
                            <th class="pl-2" style="position:sticky;top:0;background:#000;z-index:1;">Metric</th>
                            <th class="pr-2 text-right" style="position:sticky;top:0;background:#000;z-index:1;">Value</th>
                        </tr>
                    </thead>
                    ${context.state.metricGroups.map(group => {
                        // Only state granularity metrics
                        let stateMetrics = group.metrics.filter(metric => metric.granularity === 'state');
                        let allUnavailable = true;
                        let rows = stateMetrics.map(metric => {
                            let dataRow = _.find(context.state.data, ['metric', metric.slug]);
                            let data = _.find(dataRow?.data || [], (row) => row.state === stateAbbreviation);
                            let value = data?.value !== undefined ? data.value : 'Unavailable';

                            if (value !== 'Unavailable') {
                                allUnavailable = false;
                                if (metric.type === 'bool') {
                                    value = value == 1 ? 'True' : 'False';
                                } else if (metric.type === 'int' || metric.type === 'currency') {
                                    value = parseFloat(value.toString().replace(/[^0-9.]/g, '')).toFixed(0);
                                    value = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                                } else if (metric.type === 'float') {
                                    value = parseFloat(value).toFixed(2);
                                }
                            }

                            // Skip row if value is 'Unavailable'
                            if (value === 'Unavailable') return '';

                            return `
                                <tr class="text-gray-900">
                                    <td class="text-base pl-2 ${context.state.selectedMetrics.includes(metric) ? 'font-semibold' : ''}">${metric.label}</td>
                                    <td class="text-base text-right pr-2 flex justify-end ${context.state.selectedMetrics.includes(metric) ? 'font-semibold' : ''}">
                                        <span>${value !== 'Unavailable' && metric.type === 'currency' ? '$' : ''}</span>
                                        <span>${value}</span>
                                        <span>${value !== 'Unavailable' && metric.type === 'percentage' ? '%' : ''}</span>
                                    </td>
                                </tr>
                            `;
                        }).join('');
                        // Skip the entire group if all metrics are unavailable (N/A)
                        if (allUnavailable) return '';
                        return `
                            <tbody>
                                <tr style="background:#e0e7ef;">
                                    <td class="font-bold text-base py-1 pl-2">${group.label || group.name}</td>
                                    <td class="text-right font-bold text-base py-1 pr-2"></td>
                                </tr>
                                ${rows}
                            </tbody>
                        `;
                    }).join('')}
                </table>
            `;

            return `
                <div class="flex flex-col gap-y-2 px-3 py-1">
                    <div class="flex items-center justify-between">
                        <h1 class="text-lg font-bold">${state}</h1>
                        <div class="flex items-center gap-x-3">
                            <div class="rounded-md p-2 text-lg font-bold" style="background-color: ${feature.getProperty('color')}; color: #111827">
                                ${stateScore}%
                            </div>
                            <button onclick="closeCRESiteIQInfoBubble()">
                                <svg class="w-5 h-5 text-gray-500 hover:text-gray-700" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                                  <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
                                </svg>
                            </button>
                        </div>
                    </div>

                    <div class="px-2">
                        <input 
                            type="text" 
                            id="metricSearch" 
                            placeholder="Search metrics..." 
                            class="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                            onkeyup="window.filterMetrics()"
                        >
                    </div>

                    <div class="overflow-y-auto" style="max-height: 400px">
                        ${tableHtml}
                    </div>

                    <script>
                        // Focus the search input when the info window opens
                        (function() {
                            const searchInput = document.getElementById('metricSearch');
                            if (searchInput) {
                                searchInput.focus();
                                // Trigger filter in case there's any text in the search box
                                window.filterMetrics();
                            }
                        })();
                    </script>
                </div>
            `;
        },

        async generateCRESiteIQZipInfoWindow(context, feature) {
            let metricData = await context.dispatch('loadCRESiteIQForZipCode', feature.getProperty('zcta5_name')[0]);
            // Build a single table with one header and group each metric group as a tbody
            let tableHtml = `
                <table class="border-spacing-2 min-w-[350px]">
                    <thead>
                        <tr>
                            <th class="pl-2">Metric</th>
                            <th class="pr-2 text-right">Value</th>
                        </tr>
                    </thead>
                    ${context.state.metricGroups.map(group => {
                        // Only zip granularity metrics
                        let zipMetrics = group.metrics.filter(metric => metric.granularity === 'zip');
                        let allUnavailable = true;
                        let rows = zipMetrics.map(metric => {
                            let row = _.find(metricData.data, ['metric_id', metric.id]);
                            const { value, hasValue } = formatMetricValue(row?.value, metric.type);
                            if (hasValue) allUnavailable = false;
                            // Skip row if value is 'Unavailable'
                            if (value === 'Unavailable') return '';
                            return `
                                <tr class="text-gray-900">
                                    <td class="text-lg pl-2 ${context.state.selectedMetrics.includes(metric) ? 'font-semibold' : ''}">${metric.label}</td>
                                    <td class="text-lg text-right pr-2 flex justify-end ${context.state.selectedMetrics.includes(metric) ? 'font-semibold' : ''}">
                                        <span>${value !== 'Unavailable' && metric.type === 'currency' ? '$' : ''}</span>
                                        <span>${value}</span>
                                        <span>${value !== 'Unavailable' && metric.type === 'percentage' ? '%' : ''}</span>
                                    </td>
                                </tr>
                            `;
                        }).join('');
                        // Skip the entire group if all metrics are unavailable (N/A)
                        if (allUnavailable) return '';
                        return `
                            <tbody>
                                <tr style="background:#e0e7ef;">
                                    <td class="font-bold text-base py-1 pl-2">${group.label || group.name}</td>
                                    <td class="text-right font-bold text-base py-1 pr-2"></td>
                                </tr>
                                ${rows}
                            </tbody>
                        `;
                    }).join('')}
                </table>
            `;

            // Add the filter function to the global window object if it doesn't exist
            if (typeof window.filterMetrics !== 'function') {
                window.filterMetrics = function() {
                    const input = document.getElementById('metricSearch');
                    if (!input) return;
                    
                    const filter = input.value.toLowerCase();
                    const table = document.querySelector('.overflow-y-auto table');
                    if (!table) return;
                    
                    const rows = table.querySelectorAll('tbody tr');
                    
                    rows.forEach(row => {
                        const text = row.textContent.toLowerCase();
                        row.style.display = text.includes(filter) ? '' : 'none';
                    });
                    
                    // Show/hide empty groups
                    const groups = table.querySelectorAll('tbody');
                    groups.forEach(group => {
                        const hasVisibleRows = Array.from(group.querySelectorAll('tr')).some(
                            row => row.style.display !== 'none'
                        );
                        group.style.display = hasVisibleRows ? '' : 'none';
                    });
                };
            }

            return `
                <div class="flex flex-col gap-y-2 pl-3 py-1">
                    <div class="flex items-center justify-between">
                        <div class="flex flex-col">
                            <p class="text-lg font-bold">${metricData.zip}</p>
                            <p class="text-base">${metricData.city}, ${metricData.state.state}</p>
                        </div>
                        <div class="flex items-center gap-x-3">
                            <div class="rounded-md p-2 text-lg font-bold" style="background-color: ${feature.getProperty('color')}; color: #111827">
                                ${feature.getProperty('score') || '0'}%
                            </div>
                            <button onclick="closeCRESiteIQInfoBubble()">
                                <svg class="w-5 h-5 text-gray-500 hover:text-gray-700" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                                  <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
                                </svg>
                            </button>
                        </div>
                    </div>

                    <div class="px-2">
                        <input 
                            type="text" 
                            id="metricSearch" 
                            placeholder="Search metrics..." 
                            class="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                            onkeyup="window.filterMetrics()"
                        >
                    </div>

                    <div class="overflow-y-auto" style="max-height: 300px">
                        ${tableHtml}
                    </div>
                    
                    <script>
                        // Focus the search input when the info window opens
                        (function() {
                            const searchInput = document.getElementById('metricSearch');
                            if (searchInput) {
                                searchInput.focus();
                                // Trigger filter in case there's any text in the search box
                                window.filterMetrics();
                            }
                        })();
                    </script>
                </div>
            `;
        },

        async generateGeoJson(context, coordinates) {
            return {
                "type": "FeatureCollection",
                "features": [
                    {
                        "type": "Feature",
                        "geometry": JSON.parse(coordinates)
                    },
                ]
            }
        },

        highlightFeature(context, feature) {
            context.rootState.reatlas.map.data.overrideStyle(feature, { strokeWeight: 3 });
        },

        panToFeature(context, feature) {
            return;
        },

        resetFeatureStyle(context, feature) {
            if (context.rootState.reatlas.infoWindow.getMap() == null) {
                context.rootState.reatlas.map.data.overrideStyle(feature, {
                    fillColor: feature.getProperty('color'),
                    fillOpacity: context.state.fillOpacity,
                    strokeWeight: context.state.strokeWeight
                });
            }
        },

        resetFeatures(context) {
            context.rootState.reatlas.map.data.forEach(feature => {
                if (feature.getProperty('type') == 'area') {
                    context.rootState.reatlas.map.data.overrideStyle(feature, {
                        fillColor: feature.getProperty('color'),
                        strokeWeight: context.state.strokeWeight,
                        fillOpacity: context.state.fillOpacity
                    });
                }
            });
        },

        async updateCRESiteIQMetrics(context) {
            if (context.state.boundary == 'state') {
                context.state.data.forEach(row => {
                    let key = _.findKey(context.getters.metrics, ['slug', row.metric]);

                    context.state.metrics[key].min_value = parseInt(row.min);
                    context.state.metrics[key].max_value = parseInt(row.max);
                });
            }
        },

        async filterCRESiteIQZipBoundaries(context) {
            let bounds = context.rootState.reatlas.map.getBounds();

            await context.rootState.reatlas.map.data.setStyle(feature => {
                let isInBounds = bounds.contains({
                    lat: parseFloat(feature.getProperty('INTPTLAT10')),
                    lng: parseFloat(feature.getProperty('INTPTLON10'))
                });

                return {
                    visible: isInBounds,
                    strokeWeight: context.state.strokeWeight,
                    fillOpacity: context.state.fillOpacity
                };
            });
        },

        async scoreCRESiteIQStates(context) {
            console.log('start scoring');

            if (!context.state.selectedMetrics.length) {
                console.log('no metrics, end scoring');
                context.rootState.reatlas.map.data.setStyle(feature => {
                    return {
                        fillColor: "#7a7a7a",
                        strokeWeight: context.state.strokeWeight,
                        fillOpacity: 0.5
                    }
                });
                console.log('end scoring');
                return;
            }

            let features = [];
            context.state.buckets = [100, 80, 60, 40, 20];

            context.rootState.reatlas.map.data.forEach(feature => {
                if (feature.getProperty('type') == 'area' && feature.getProperty('visible') == true) {
                    features.push(feature);
                }
            });

            if (features.length == 0) {
                console.log('no features, end scoring');
                return;
            }

            let processes = features.map(feature => {
                let state = feature.getProperty('NAME');
                let stateScore = 0;
                let stateAbbreviation = _.find(context.rootState.reatlas.states, ['name', state])['state'];

                context.state.selectedMetrics.map(metric => {
                    let min = parseFloat(metric.filter_level_min);
                    let max = parseFloat(metric.filter_level_max);
                    let dataRow = _.find(context.state.data, ['metric', metric.slug]);

                    let data = _.find(dataRow.data, (row) => {
                        return row.state == stateAbbreviation;
                    });

                    if (!data) {
                        context.rootState.reatlas.map.data.overrideStyle(feature, {
                            visible: false
                        });

                        return;
                    }

                    //look up and store values for each metric for this given state/zip code/county etc.
                    feature.setProperty('metricData', {
                        'state': stateAbbreviation,
                        'data': data
                    });

                    switch (metric.filter_type) {
                        case 'lt':
                            min = parseFloat(metric.min_value);
                            max = parseFloat(metric.filter_level_min);
                            break;
                        case 'gt':
                            min = parseFloat(metric.filter_level_min);
                            max = parseFloat(metric.max_value);
                            break;
                        case 'range':
                            min = parseFloat(metric.filter_level_min);
                            max = parseFloat(metric.filter_level_max);
                            break;
                    }

                    let value = data.value != null
                        ? parseFloat(data.value)
                        : (metric.higher_is_better ? min : max);

                    let weightedScore;
                    
                    // Special handling for boolean metrics or when min equals max
                    if (metric.type === 'bool' || min === max) {
                        if (value === max) {
                            weightedScore = 1;
                        } else {
                            weightedScore = 0;
                        }
                    } else {
                        // Normal numeric range calculation
                        weightedScore = (value - min) / (max - min);
                        if (!metric.higher_is_better) {
                            weightedScore = 1 - weightedScore;
                        }
                    }

                    weightedScore *= metric.weight;

                    stateScore += weightedScore;
                });

                stateScore = Math.round(stateScore);
                stateScore = stateScore > 100 ? 100 : stateScore;
                stateScore = stateScore < 0 ? 0 : stateScore;

                let scoreKey = _.findLastIndex(context.state.buckets, (score) => {
                    return stateScore <= score;
                })

                feature.setProperty('color', context.state.bucketColors[scoreKey]);
                feature.setProperty('score', stateScore);

                let isVisible = stateScore >= context.state.minScore;

                context.rootState.reatlas.map.data.overrideStyle(feature, {
                    fillColor: context.state.bucketColors[scoreKey],
                    strokeWeight: context.state.strokeWeight,
                    fillOpacity: context.state.fillOpacity,
                    visible: isVisible
                });
            });

            console.log('end scoring');
            return await Promise.all(processes);
        },

        async scoreCRESiteIQZips(context) {
            console.log('start scoring');

            if (!context.state.selectedMetrics.length) {
                context.rootState.reatlas.map.data.setStyle(feature => {
                    return {
                        fillColor: "#eeeeee",
                        strokeWeight: context.state.strokeWeight,
                        fillOpacity: context.state.fillOpacity
                    }
                });
                console.log('end scoring');
                return;
            }

            let features = [];
            context.state.buckets = [100, 80, 60, 40, 20];

            context.rootState.reatlas.map.data.forEach(feature => {
                if (feature.getProperty('type') === 'area' && feature.getProperty('visible') === true) {
                    features.push(feature)
                }
            });

            if (features.length == 0) {
                console.log('no features, end reset');
                return;
            }

            let processes = features.map(feature => {

                let zip = feature.getProperty('zcta5_code')[0];
                let data = _.find(context.state.data, ['zip', zip]);
                let zipScore = 0;

                if (!data) {
                    context.rootState.reatlas.map.data.overrideStyle(feature, {
                        visible: false
                    });

                    return;
                }

                context.state.selectedMetrics.map(metric => {
                    let min = parseFloat(metric.filter_level_min);
                    let max = parseFloat(metric.filter_level_max);

                    switch (metric.filter_type) {
                        case 'lt':
                            min = parseFloat(metric.min_value);
                            max = parseFloat(metric.filter_level_min);
                            break;
                        case 'gt':
                            min = parseFloat(metric.filter_level_min);
                            max = parseFloat(metric.max_value);
                            break;
                        case 'range':
                            min = parseFloat(metric.filter_level_min);
                            max = parseFloat(metric.filter_level_max);
                            break;
                    }

                    let row = _.find(data.data, ['metric_id', metric.id]);
                    let value = row ? parseFloat(row['value']).toFixed(0) : (metric.higher_is_better ? metric.filter_level_min : metric.filter_level_max);

                    if (parseFloat(value) < parseFloat(min)) {
                        value = parseFloat(min);
                    } else if (parseFloat(value) > parseFloat(max)) {
                        value = parseFloat(max);
                    }

                    if (context.state.customMetricCalculations[metric.slug]) {
                        var weightedScore = context.state.customMetricCalculations[metric.slug](min, value, max);
                    } else {
                        weightedScore = ((value - min) / (max - min));

                        if (!metric.higher_is_better) {
                            weightedScore = 1 - weightedScore;
                        }
                    }

                    weightedScore *= metric.weight;

                    zipScore += weightedScore;
                });

                zipScore = Math.round(zipScore);

                zipScore = zipScore > 100 ? 100 : zipScore;
                zipScore = zipScore < 0 ? 0 : zipScore;

                let scoreKey = _.findLastIndex(context.state.buckets, (score) => {
                    return zipScore <= score;
                })

                feature.setProperty('color', context.state.bucketColors[scoreKey]);
                feature.setProperty('score', zipScore);

                let isVisible = zipScore >= context.state.minScore;

                context.rootState.reatlas.map.data.overrideStyle(feature, {
                    fillColor: context.state.bucketColors[scoreKey],
                    strokeWeight: context.state.strokeWeight,
                    fillOpacity: context.state.fillOpacity,
                    visible: isVisible
                });

                //look up and store values for each metric for this given state/zip code/county etc.
                feature.setProperty('metricData', {
                    'zip': zip,
                    'city': data.city,
                    'state': data.state,
                    'data': _.map(context.state.metrics, function (metric) {
                        return {
                            'metric': metric.slug,
                            'value': data.data[metric.slug]
                        }
                    })
                });
            });

            console.log('end scoring');
            return await Promise.all(processes);
        },

        async filterByScore(context) {
            console.log('filtering by score');

            await context.dispatch("filterCRESiteIQData");

            await context.rootState.reatlas.map.data.forEach(feature => {
                if (feature.getProperty('type') == 'area' && feature.getProperty('visible') == true) {
                    let isVisible = feature.getProperty('score') >= context.state.minScore;

                    feature.setProperty('visible', isVisible);

                    context.rootState.reatlas.map.data.overrideStyle(feature, {
                        fillColor: feature.getProperty('color'),
                        fillOpacity: context.state.fillOpacity,
                        strokeWeight: context.state.strokeWeight,
                        visible: isVisible
                    });
                }
            });

            context.dispatch('refreshScores');
        },

        async resetCRESiteIQMap(context, forState) {
            console.log('start reset', forState);
            let features = [];

            context.rootState.reatlas.map.data.forEach(feature => {
                if (forState != undefined && feature.getProperty('type') == 'area' && !feature.getProperty('ste_name').includes(forState)) {
                    return;
                }

                features.push(feature)
            });

            if (features.length == 0) {
                console.log('no features, end reset');
                return;
            }

            let processes = features.map(feature => {
                feature.setProperty('visible', true);

                context.rootState.reatlas.map.data.overrideStyle(feature, {
                    fillColor: feature.getProperty('color'),
                    fillOpacity: context.state.fillOpacity,
                    strokeWeight: feature.getProperty('strokeWeight') || context.state.strokeWeight,
                    visible: true
                });
            });

            return Promise.all(processes);

        },

        async clearCRESiteIQMap(context) {
            context.state.visibleFeatures = [];

            await context.rootState.reatlas.map.data.forEach(feature => {
                if (feature.getProperty('type') == 'area') {
                    context.rootState.reatlas.map.data.remove(feature);
                }
            });
        },

        showCRESiteIQWindow(context) {
            document.getElementById('building-list-container').classList.add('hidden');
            document.getElementById('cresiteiq-container').classList.remove('hidden');
            document.getElementById('cresiteiq-container-right').classList.remove('hidden');
            context.state.isCollapsed = false;
        },

        hideCRESiteIQWindow(context) {
            document.getElementById('building-list-container').classList.remove('hidden');
            document.getElementById('cresiteiq-container').classList.add('hidden');
            document.getElementById('cresiteiq-container-right').classList.add('hidden');
            context.state.isCollapsed = context.rootState.reatlas.layers.cresiteiq.isOn;
        }
    },

    getters: {
        visibleFeatures: (state, getters, store) => {
            let features = [];

            store.reatlas.map?.data.forEach((feature) => {
                console.log('is visible', feature.getProperty('visible'));

                if (feature.getProperty('visible') == true) {
                    features.push(feature);
                }
            });


            return features;

        },

        metrics: (state) => {
            return state.metricGroups.flatMap(group => group.metrics);
        },

        scorableMetrics: (state) => {
            return state.metrics.filter(metric => {
                return metric.min_value != metric.filter_level_min || metric.max_value != metric.filter_level_max;
            });
        },

        selectedMetric(state) {
            return _.find(state.metrics, ['slug', state.selectedMetricSlug]);
        },
    }
};
